(() => {
  const initialized = new WeakSet();
  const initialize = (scope) => {
    scope.querySelectorAll('.tt-home-hero').forEach((slideshow) => {
      if (initialized.has(slideshow)) return;
      initialized.add(slideshow);
      slideshow.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        if (event.target.matches('input, select, textarea')) return;
        event.preventDefault();
        slideshow.querySelector(event.key === 'ArrowRight' ? '[name="next"]' : '[name="previous"]')?.click();
      });
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const autoplay = slideshow.querySelector('.slideshow__autoplay');
        if (autoplay && !autoplay.classList.contains('slideshow__autoplay--paused')) autoplay.click();
      }
    });
  };
  customElements.whenDefined('slideshow-component').then(() => initialize(document));
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
